import { render, staticRenderFns } from "./CourseLibraryPage.vue?vue&type=template&id=1a9b4b2a&scoped=true"
import script from "./CourseLibraryPage.vue?vue&type=script&lang=js"
export * from "./CourseLibraryPage.vue?vue&type=script&lang=js"
import style0 from "./CourseLibraryPage.vue?vue&type=style&index=0&id=1a9b4b2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b4b2a",
  null
  
)

export default component.exports